
const QVCForm = ({ submitHandler, changeHandler }) => {

    return (
        <form className="qvc-booking-form onboard-form" onSubmit={submitHandler}>

            <div className="onboard-form-field">
                <label>
                    QVC Date:
                </label>

                <input type="date" name="QVCDate" onChange={changeHandler} required />
            </div>

            <div className="onboard-form-field">
                <label>
                    QVC Time:
                </label>
                <input type="time" name="QVCTime" onChange={changeHandler} required />
            </div>

            <div className="onboard-form-field">
                <label>
                    QVC Booking – Attachment
                </label>

                <input type='file' name="QVCBookingAttachment" onChange={changeHandler} accept="image/png, image/jpeg, application/pdf" required />
            </div>

            <div className="submit-btn">
                <button className="onboard-general-btn" type="submit">Update Details</button>
            </div>
        </form>
    )
}

export default QVCForm;